(function (global) {
  var TZ = 'America/Los_Angeles';
  var WEEKDAY = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function ptParts(date) {
    var bag = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') bag[part.type] = part.value;
    });
    var hour = parseInt(bag.hour, 10);
    if (hour === 24) hour = 0;
    return {
      weekday: WEEKDAY[bag.weekday],
      year: parseInt(bag.year, 10),
      month: parseInt(bag.month, 10),
      day: parseInt(bag.day, 10),
      hour: hour,
      minute: parseInt(bag.minute, 10),
      second: parseInt(bag.second, 10)
    };
  }

  function addDays(year, month, day, amount) {
    var date = new Date(Date.UTC(year, month - 1, day + amount));
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate()
    };
  }

  function ptWallToDate(year, month, day, hour, minute) {
    var date = new Date(Date.UTC(year, month - 1, day, hour + 8, minute, 0));
    for (var i = 0; i < 4; i += 1) {
      var part = ptParts(date);
      var wanted = Date.UTC(year, month - 1, day, hour, minute, 0);
      var got = Date.UTC(part.year, part.month - 1, part.day, part.hour, part.minute, 0);
      date = new Date(date.getTime() + (wanted - got));
    }
    return date;
  }

  function longDate(year, month, day) {
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC'
    }).format(new Date(Date.UTC(year, month - 1, day, 12, 0, 0)));
  }

  function currentCycle(now) {
    var part = ptParts(now || new Date());
    var seconds = part.hour * 3600 + part.minute * 60 + part.second;
    var cutoffSeconds = 23 * 3600 + 59 * 60;
    var daysToThursday = (4 - part.weekday + 7) % 7;
    if (part.weekday > 4 || (part.weekday === 4 && seconds >= cutoffSeconds)) {
      daysToThursday = daysToThursday === 0 ? 7 : daysToThursday;
    }
    var thursday = addDays(part.year, part.month, part.day, daysToThursday);
    var sunday = addDays(thursday.year, thursday.month, thursday.day, 3);
    var thursdayLabel = longDate(thursday.year, thursday.month, thursday.day);
    var sundayLabel = longDate(sunday.year, sunday.month, sunday.day);
    return {
      cutoff: ptWallToDate(thursday.year, thursday.month, thursday.day, 23, 59),
      thursdayLabel: thursdayLabel,
      sundayLabel: sundayLabel,
      sundayHeading: sundayLabel,
      cutoffText: 'Order by ' + thursdayLabel + ' at 11:59 PM PT',
      announceLead: 'NOW TAKING ORDERS FOR ' + sundayLabel.toUpperCase() + ' DELIVERY',
      announceCutoff: 'ORDER BY ' + thursdayLabel.toUpperCase() + ' AT 11:59 PM PT',
      announceWindow: 'DELIVERY WINDOW: SUNDAY 4 PM – 4 AM',
      announceLeadShort: sundayLabel.toUpperCase() + ' DELIVERY',
      announceCutoffShort: thursdayLabel.toUpperCase() + ' AT 11:59 PM PT',
      announceWindowShort: 'SUNDAY 4 PM – 4 AM'
    };
  }

  global.mpkOrderCycle = currentCycle;
})(window);
